import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps, withState } from 'recompose';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import fh from '../../../../helpers/form.helper';
import ModelService from '../../../../services/tokens-balance.service';
import CardLoading from '../../../../components/CardLoading';
import WithLoading from '../../../../components/WithLoading';
import CompanyService from "../../../../services/company.service";

const defaultFormData = {
  name: '',
  type: 1,
  is_default: 0,
};

const onChangeCompanyInput = props => async input => {
  await props.setCompanyInput(input);
};

const searchCompany = props => async () => {
  return await CompanyService.getAll({ title: props.companyInput })
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { image, isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    image: image && image.id ? image.id : '',
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.removeTempFile('image');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  withState('countries', 'setCountries', []),
  withState('searchCity','setSearchCity', ''),
  withState('companyInput', 'setCompanyInput', ''),
  defaultProps({
    tab: () => '<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>',
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      if (this.props.match && this.props.match.params.company_id) {
        ModelService.baseUrl = ModelService.defaultBaseUrl.replace(':company_id', this.props.match.params.company_id);
        ModelService.baseRoute = ModelService.defaultBaseRoute.replace(':company_id', this.props.match.params.company_id);
      }
      await fh.initModelData(this.props, applyModel, ModelService);
      window.recaptchaOptions = {
        lang: this.props.i18n.language,
      };
    },
  }),
  withProps(props => ({
    title: props.t('Tokens balance') + fh.getTitleEnd(props),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    onChangeCompanyInput,
    searchCompany,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Item, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/companies/tokensBalance/item/index.js